// extracted by mini-css-extract-plugin
export default {"hed":"yl","blend":"zl","resultsBox":"Al","left":"Bl","right":"Cl","center":"El","base":"Fl","milk":"Gl","text":"Hl","hyroxresult":"Il","margin":"Jl"};
    if(module.hot) {
      // 1711717530267
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  